import { stdObject } from "../../../data/types/stdObject";
import { useTranslation } from "react-i18next";
import { getRealCode } from "../../../utils/getRealCode";
import { useStructureContext } from "../../../context/StructureContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { extraListCodes, extrasNewCodes } from "../../../data/main";
import { useReactToPrint } from "react-to-print";

export default function useSearchBar() {
  const { t } = useTranslation();
  const { type, section, headers, subSections } = useStructureContext();
  const user: any = useSelector((state: RootState) => state.data.user);
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const mainUser =
    section.code in headers
      ? ["user", "default"].every((key) => key in headers[section.code])
        ? headers[section.code].user.length > 0
          ? headers[section.code].user
          : headers[section.code].default
        : []
      : [];

  const mainSearch = mainUser
    .filter((e: stdObject) => e.BUSCAB === 1)
    .sort((a: any, b: any) => b.ORDCAB - a.ORDCAB);

  const mainSort = mainUser
    .filter((e: stdObject) => e.BORCAB > 0)
    .map((e: stdObject) => {
      return {
        label: t(`c.${getRealCode(e.CODCAB, section.code)}`),
        value: e.CODCAB,
      };
    });

  const checkIfCreate = () => {
    switch (section.id) {
      case "C2":
      case "C3":
        return false;
      case "D4":
      case "V1":
      case "F10":
      case "Z6":
        return userAccess[section.id[0]][section.id] === 2;
      default:
        return extrasNewCodes.includes(section.code)
          ? true
          : section.id
            ? extraListCodes.includes(section.code)
              ? !!user[`${section.code}N`]
              : !!subSections[`${section.id}N`]
            : false;
    }
  };

  return {
    type,
    section,
    mainSearch,
    mainSort,
    t,
    checkIfCreate,
  };
}
